<div class="page" style="padding: 20px; background: white;">

    <div class="k-d-flex k-d-flex-row k-mb-3">
        <h5>{{ 'CreateATimeOffInLieuType' | translate: {Default: "Create a Time Off In Lieu Type"} }}</h5>
        <div class="k-flex-grow"></div>
        <div class="buttons-container">
            <button mat-raised-button appPreventDoubleClick (throttledClick)="cancel()" class="k-mr-2">{{ 'Close' | translate: {Default: "Close"} }}</button>
            <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="saveForm()" [disabled]="!form.valid">{{ 'Save' | translate: {Default: "Save"} }}</button>
        </div>
    </div>

    <div class="form-section-title">
    </div>

    <div class="form" [formGroup]="form">


        <app-localization-text-form-field
            [formElement]="{ formControl: 'localizations', localizationValueParam: 'text', text: ('ToilTypeName' | translate: {Default: 'TOIL Type Name'}), disabled: 'false' }"
            [parentGroup]="form"
            [cultures]="cultures"
            (emitAddtoFormArray)="addNewLocalization()"
            (emitDeleteFromFormArray)="deleteLocalization($event.index)"
        ></app-localization-text-form-field>



        <div class="form-section-title">
            <h6>{{ 'TimeOffInLieuIcon' | translate: {Default: "Time Off In Lieu Icon"} }}</h6>
        </div>
        <div class="k-mb-3">
            <div *ngIf="filePath && filePath !== ''; else noImage">
                <img [src]="filePath" [alt]="form.value.image.name" class="timeoff-type-icon">
            </div>
            <ng-template #noImage>
                <div class="no-image"></div>
            </ng-template>
        </div>

        <div class="k-mb-3">
            <button type="button" mat-raised-button appPreventDoubleClick (throttledClick)="fileInput.click()">{{ 'ChooseFile' | translate: {Default: "Choose File"} }}</button>
            <input hidden type="file" accept="image/*" #fileInput (change)="imagePreview($event)"/>
        </div>

    </div>
</div>
